import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import { Checkbox } from '@bwoty-web/ui-kit';

import './departureAirportFilterContent.scss';

const DepartureAirportFilterContent = (props) => {
  const {
    departureAirportOptions,
    selectedDepartureAirports,
    addDepartureAirportFilter,
    removeDepartureAirportFilter,
    departureAirportPotentials,
  } = props;

  const handleFilterChange = (event, airport) => {
    const { target } = event;
    if (target.checked) {
      addDepartureAirportFilter(airport);
    } else {
      removeDepartureAirportFilter(airport);
    }
  };

  const airportOptions = departureAirportOptions.map((depAirport) => {
    return (
      <Checkbox
        key={uniqid('po-list-dep-airport-filter-option-')}
        className="po-list-dep-airport-filter-content-option"
        uniqueId={depAirport.value}
        onChange={event => handleFilterChange(event, depAirport.value)}
        checked={selectedDepartureAirports.includes(depAirport.value)}
        disabled={departureAirportPotentials[depAirport.value] === 0}
      >
        {`${depAirport.name} (${departureAirportPotentials[depAirport.value]})`}
      </Checkbox>
    );
  });

  return (
    <div className="po-list-dep-airport-filter-content">
      {airportOptions}
    </div>
  );
};

DepartureAirportFilterContent.propTypes = {
  departureAirportOptions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  selectedDepartureAirports: PropTypes.arrayOf(PropTypes.string).isRequired,
  addDepartureAirportFilter: PropTypes.func.isRequired,
  removeDepartureAirportFilter: PropTypes.func.isRequired,
  departureAirportPotentials: PropTypes.shape().isRequired,
};

export default DepartureAirportFilterContent;
